import { ReactNode } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import {
   ContentNode,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
} from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { MedicalDocumentationPasswordDetailsForm } from './MedicalDocumentationPasswordDetailsForm';

type MedicalDocumentationPasswordDetailsShowModalInterceptorProps = Readonly<{
   filePassword: string | null;
   successMessage?: ContentNode;
   title: TranslatableText;
   children: ReactNode;
}>;

export const MedicalDocumentationPasswordDetailsShowModalInterceptor = (
   props: MedicalDocumentationPasswordDetailsShowModalInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'medicalDocumentationPasswordDetailsView'}
         title={props.title}
         modalWidth={ModalWidth.NORMAL}
         content={({ resolve }) => (
            <>
               <MedicalDocumentationPasswordDetailsForm
                  successMessage={props.successMessage}
                  filePassword={props.filePassword!}
               />

               <ModalConfirmButton label={translationKeys.close} onClick={resolve} />
               <ModalCloseButton onClick={resolve} />
            </>
         )}
         shouldShowModal={Boolean(props.filePassword)}
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
